/*
  Opens desktop dropdown menus on hover. Loaded by snippets/oumnh-global.liquid.
  Was assets/menu-hover-dropdown.js, loaded from a script tag added to sections/header.liquid.
*/
(() => {
  if (!window.matchMedia('(hover: hover)').matches) return;

  const init = () => {
    document.querySelectorAll('.header__inline-menu details').forEach((details) => {
      if (details.dataset.oumnhHover) return;
      details.dataset.oumnhHover = 'true';
      details.addEventListener('mouseenter', () => details.setAttribute('open', ''));
      details.addEventListener('mouseleave', () => details.removeAttribute('open'));
    });
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
